import React from 'react';
import { Form } from 'react-final-form';
import dayjs from 'dayjs';

import ContactFormInner from './ContactFormInner';

import validate from '../../../utils/validate';
import { contactFormSchema } from './validation';
import callApi from '../../../service/callApi';
import sendRequest from '../../../service/sendRequest';

function ContactForm({ onClose }) {
  const handleSendHelpRequest = (values) => {
    const notEmptyValues = Object.fromEntries(Object.entries(values).filter(([_, value]) => value !== ''));

    if (notEmptyValues.bugTime) {
      const formattedDate = dayjs(notEmptyValues.bugTime).format('DD.MM.YYYY HH:mm');
      notEmptyValues.bugTime = formattedDate;
    }

    sendRequest(() => callApi.post('/api/support/contact', notEmptyValues));
  };

  const initialValues = {
    requestType: '',

    contactEmail: '',

    bugTime: null,
    bugProjectName: '',

    supportTopic: '',

    description: '',
  };

  return (
    <Form
      initialValues={initialValues}
      onSubmit={handleSendHelpRequest}
      validate={(values) => validate(values, contactFormSchema())}
      subscription={{ submitting: true, pristine: true }}
      render={({ handleSubmit }) => <ContactFormInner onClose={onClose} onSubmit={handleSubmit} />}
    />
  );
}

export default ContactForm;
